module.exports = __webpack_public_path__ + "static/media/home_logo_ch@3x.64285e86.png";